import {AddressResponseBodyV2} from '@dms/api/customer';

import type {BusinessInfoData} from './BusinessInfoData';

export type BusinessInfo = {
  id: string;
  businessInfoData: BusinessInfoData;
  businessAddress: AddressResponseBodyV2 | null;
};
